import { action, observable, runInAction } from 'mobx';
import { StringStore } from 'ui/base/input';
import { IAccountsDomain } from 'services/accounts/types';
import { UpdatePangolinResult, update } from 'services/accounts/pangolin_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class AddPangolinRenameStore {
  readonly nickname: StringStore;

  @observable.ref
  nicknameError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.nickname = new StringStore('');
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSubmit(domain: IAccountsDomain, id: string): Promise<UpdatePangolinResult> {
    const result = await update({
      domain,
      id,
      nickname: this.nickname.value,
    });
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.nicknameError = result.nicknameError;
      }
      return result;
    });
  }
}
